import {
    FETCH_FORGET_SUCCESS,
    FETCH_LOGIN_SUCCESS
} from "./type";
import axios from "axios";
import { API_ENDPOINT } from '../../AppConfig';
import { hideLoading,showLoading } from 'react-redux-loading-bar';
import { showSnack } from 'react-redux-snackbar';

export let EmailBool = '';

export function SendingEmail(data) {

    return (dispatch, getState) => {
        let uri = `${API_ENDPOINT}/forgetPassword`;
        dispatch(showLoading());
        console.log("SendingEmaillll", JSON.stringify(data) )
        axios.post(uri, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json',
                'Accept-Language': "ar"

            }
        })
            .then(response => {
                saveToLocalStorage('email', data.email);
                dispatch({ type: FETCH_FORGET_SUCCESS, payload: 'confirmationCode' });
                dispatch(hideLoading());
                EmailBool = true;
            }).catch(error => {
                dispatch(hideLoading());
                if (!error.response) {
                    dispatch(showSnack('myUniqueId', {
                        label: 'خطأ فى الاتصال بالانترنت',
                        timeout: 7000,
                        button: { label: ' البريد الالكترونى' }
                    }));
                }
                else if (error.response.status === 404 || error.response.status === 403) {
                    EmailBool = false;
                    dispatch(showSnack('myUniqueId', {
                        label: 'البريد الالكترونى غير موجود',
                        timeout: 7000,
                        button: { label: ' البريد الالكترونى' }
                    }));
                }
            })
    }
}

export function ConfirmCode(data) {
    console.log("data",data)
    return (dispatch, getState) => {
        let uri = `${API_ENDPOINT}/confirmationCode`;
        dispatch(showLoading());

        axios.put(uri, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json',
                'Accept-Language': "ar"

            }
        })
            .then(response => {
                console.log("response data",response)
                dispatch({ type: FETCH_FORGET_SUCCESS, payload: 'resetPassword' });
                dispatch(hideLoading());
            }).catch(error => {
                console.log("error Message",error)
                dispatch(hideLoading());
                if (!error.response) {
                    dispatch(showSnack('myUniqueId', {
                        label: 'خطأ فى الاتصال بالانترنت',
                        timeout: 7000,
                        button: { label: 'ارسال الكود ' }
                    }));
                }
                else if (error.response.status === 400) {
                    dispatch(showSnack('myUniqueId', {
                        label: 'هذا الكود غير صحيح',
                        timeout: 7000,
                        button: { label: 'ارسال الكود ' }
                    }));
                }
            })
    }
}

export function ResetPass(data) {
    console.log("change pass:",data)
    return (dispatch, getState) => {
        let uri = `${API_ENDPOINT}/confirmationchange`;
        dispatch(showLoading());

        axios.put(uri, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json',
                'Accept-Language': "ar"

            }
        })
            .then(response => {
                saveToLocalStorage('user', JSON.stringify(response.data.user));
                saveToLocalStorage('maktaptioken', JSON.stringify(response.data.token));
                dispatch({ type: FETCH_FORGET_SUCCESS, payload: 'dashboard' });
                dispatch({ type: FETCH_LOGIN_SUCCESS, payload: response.data });
                dispatch(hideLoading());

            }).catch(error => {
                dispatch(hideLoading());
                if (!error.response) {
                    dispatch(showSnack('myUniqueId', {
                        label: 'خطأ فى الاتصال بالانترنت',
                        timeout: 7000,
                        button: { label: ' كلمة المرور الجديدة' }
                    }));
                }
            })
    }
}

export function saveToLocalStorage(key, value) {
    localStorage.setItem(key, value);
}


export function resendCode(data) {
    return (dispatch, getState) => {
        // dispatch({ type: FETCH_FORGET_SUCCESS, payload: 'email' });
        let data = {
            email: localStorage.getItem('email'),
            type: 'ADMIN'
        }
        let uri = `${API_ENDPOINT}/forgetPassword`;
        dispatch(showLoading());
        axios.post(uri, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json',
                'Accept-Language': "ar"

            }
        })
            .then(response => {
                dispatch(hideLoading());
                EmailBool = true;
            }).catch(error => {
                dispatch(hideLoading());
                if (!error.response) {
                    dispatch(showSnack('myUniqueId', {
                        label: 'خطأ فى الاتصال بالانترنت',
                        timeout: 7000,
                        button: { label: ' البريد الالكترونى' }
                    }));
                }
                else if (error.response.status === 404) {
                    EmailBool = false;
                    dispatch(showSnack('myUniqueId', {
                        label: 'البريد الالكترونى غير موجود',
                        timeout: 7000,
                        button: { label: ' البريد الالكترونى' }
                    }));
                }
            })
    
    }
}